import React from 'react';

export  const AlertDataContext = React.createContext({
  alertData: {id:0},
  setData: () => {},
});

export default AlertDataContext;